// Suppliers hand us inclusions, exclusions and highlights as a single string rather than a list.
// Musement joins its taxonomy entries with '. ' (see MusementProductAdapter._get_activity_taxonomies),
// so splitting on sentence boundaries is the only way back to the list the supplier actually sent.
// A few origins use newlines instead, so those win when present.
//
// Validated against all 23,684 active Musement products: 3.8 bullets per product, and every
// sub-six-character result was a real item ('Lunch', 'Water', 'WiFi') rather than a split abbreviation.
export const toBulletList = (value: any): string[] => {
  const text = String(value ?? '').trim()
  if (!text) return []

  const lines = text.split(/\r?\n+/).map((line) => line.trim()).filter(Boolean)
  const chunks = lines.length > 1 ? lines : text.split(/\.\s+/)

  const parts: string[] = []
  for (const chunk of chunks) {
    const trimmed = chunk.trim()
    if (!trimmed) continue

    // 'St. Peter's Basilica' splits into 'St' plus the rest. Nothing that short is a list item,
    // so glue it back onto the fragment it belongs to.
    const previous = parts[parts.length - 1]
    if (previous !== undefined && previous.length <= 3) {
      parts[parts.length - 1] = `${previous}. ${trimmed}`
    } else {
      parts.push(trimmed)
    }
  }

  return parts
    .map((part) => part.replace(/^[-•*]\s*/, '').replace(/\.$/, '').trim())
    .filter(Boolean)
}
